import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router'

import useAuth from '../../../hooks/useAuth'
import AppRoutes from '../../../routes/appRoutes'
import { useFormik } from 'formik'
import Button from '../../../components/Button/Button'
import clsx from 'clsx'
import InputPassword from '../../../components/InputText/components/InputPassword'
import {
    initialValues,
    validationSchema,
} from '../../../forms/ResetPasswordForm'

const ResetPasswordForm = props => {
    const { email, onSubmit, error } = props
    const { authenticated, role } = useAuth()

    const {
        handleSubmit,
        isValid,
        isSubmitting,
        setSubmitting,
        getFieldProps,
        touched,
        errors,
    } = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: formValues => {
            setSubmitting(true)
            onSubmit(formValues)
            setSubmitting(false)
        },
    })

    if (authenticated) {
        if (window.Intercom != null) {
            window.Intercom('shutdown')
        }
        if (role === 'admin' || role === 'salesperson') {
            return <Redirect to={AppRoutes.adminHome()} />
        } else {
            return <Redirect to={AppRoutes.home()} />
        }
    }

    return (
        <form
            onSubmit={handleSubmit}
            className="flex flex-col items-center justify-start gap-y-1 w-full"
        >
            <p className="text-base text-white text-center font-normal">
                Set a new password to the account for {email}
            </p>

            <InputPassword
                {...getFieldProps('password')}
                error={touched['password'] && errors['password']}
                label="Password"
                variant="black"
                isRequired
            />
            <InputPassword
                {...getFieldProps('password_confirmation')}
                label="Password Confirmation"
                error={
                    touched['password_confirmation'] &&
                    errors['password_confirmation']
                }
                variant="black"
                isRequired
            />
            <div className="w-full h-auto flex items-center justify-center flex-col mt-1 gap-y-4">
                <div className="flex w-full flex-col items-center justify-center gap-y-2">
                    <Button
                        text="Save"
                        type="submit"
                        variant="secondary"
                        disabled={!isSubmitting && !isValid}
                        className="w-full disabled:bg-yellow disabled:text-black disabled:border-yellow"
                    />
                </div>
                <p
                    className={clsx(
                        error ? 'visible' : 'invisible',
                        'transition-all delay-200  text-error font-medium text-sm',
                    )}
                >
                    {error}
                </p>
            </div>
        </form>
    )
}

ResetPasswordForm.propTypes = {
    email: PropTypes.string,
    onSubmit: PropTypes.func,
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.any,
    ]),
}

export default ResetPasswordForm
